// @flow
import React from "react"
import classnames from "classnames"
import type { Map } from "immutable"

import { getPlaceNameAndCode } from "common/services/utils/flight"
import type Place from "common/records/Place"

type Props = {
  className?: string,
  place: Map<string, any> | Place,
}

const TripPlace = ({ className, place }: Props) => (
  <span className={classnames("TripPlace", className)}>
    <span className="code">{place.get("code")}</span>
    <span className="name">{place.get("name")}</span>
    <span className="name-and-code">{getPlaceNameAndCode(place)}</span>
  </span>
)

export default TripPlace
